{
  "pt": {
    "constants": {
      "address": {
        "city": "Cidade",
        "country": "País",
        "number": "Número",
        "street": "Rua",
        "zip": "Código postal"
      },
      "crud": {
        "created_at": "Aangemaakt op",
        "deleted_at": "Verwijderd op",
        "updated_at": "Gewijzigd op"
      },
      "days": ["Su", "M", "Tu", "W", "O", "F", "S"],
      "languages": {
        "de": "Alemão",
        "en": "Inglês",
        "fallback_info": "Parece que esta mensagem não está disponível na sua língua. Em vez disso, estamos a utilizar a tradução existente em {fallback_locale}.",
        "fr": "Francês",
        "nl": "Holandês",
        "pl": "Polaco",
        "pt": "Português"
      },
      "languages_short": {
        "de": "DE",
        "en": "EN",
        "fr": "FR",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Imperial",
        "metric": "Métrica",
        "surface": {
          "imperial": "Pés quadrados",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      "profile_statuses": {
        "active": "Ativo",
        "added": "Ainda não foi convidado",
        "blocked": "Desativado",
        "discarded": "Eliminado",
        "invited": "Convidado",
        "invited_at": "Convidado"
      },
      "profile_statuses_descriptive": {
        "active": "Última vez que esteve ativo na plataforma: {session_ended_at}",
        "added": "Ainda não foi convidado",
        "blocked": "Desativado",
        "discarded": "Eliminado",
        "invited": "Convidado mas ainda não se inscreveu",
        "invited_at": "Convidado {invited_at}. Ainda não se inscreveu"
      },
      "profile_titles": {
        "dr": "Dr",
        "mr": "Senhor",
        "mrs": "Senhora",
        "professor": "Professor",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Dias",
        "months": "Meses",
        "weeks": "Semanas"
      },
      "time_units_count": {
        "days": "não dia | dia | dias",
        "months": "nenhum mês | mês | meses",
        "weeks": "sem semana | semana | semanas"
      },
      "timezones": {
        "America/Chicago": "América/Chicago",
        "America/Denver": "América/Denver",
        "America/Los_Angeles": "América/Los Angeles",
        "America/New_York": "América/Nova Iorque",
        "Europe/Brussels": "Europa/Bruxelas",
        "Europe/Lisbon": "Europa/Lisboa",
        "Europe/London": "Europa/Londres",
        "Europe/Madrid": "Europa/Madrid"
      },
      "wind_orientations": {
        "east": "Leste",
        "north": "Norte",
        "northeast": "Nordeste",
        "northwest": "Noroeste",
        "select": "Selecionar orientação",
        "south": "Sul",
        "southeast": "Sudeste",
        "southwest": "Sudoeste",
        "west": "Oeste"
      }
    }
  }
}
